import type { IconProps } from '../types/IconProps.ts';
export const Equalizer: IconProps = {
    name: 'Equalizer',
    children: [
        `<path d="M2 10v4M22 10v4M6 6v12M18 5v13M10 3v17.5M14 8v8" />`,
    ]
};